import { render, staticRenderFns } from "./Profilo.vue?vue&type=template&id=e3937186&"
import script from "./Profilo.vue?vue&type=script&lang=js&"
export * from "./Profilo.vue?vue&type=script&lang=js&"
import style0 from "./Profilo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports